/**
 * Mirrors useAuth's PREVIOUS_SESSION localStorage key onto <html> so CSS can
 * tell, before React runs, whether this browser last had a signed-in session.
 * The prerendered HTML is the same for everyone; this lets it show the
 * signed-in header skeleton from the first paint for returning users.
 */
const PREVIOUS_SESSION_KEY = "PREVIOUS_SESSION";

export const PREVIOUS_SESSION_ATTRIBUTE = "data-previous-session";

/** Selector for styles that apply when the last session was a consumer's. */
export const PREVIOUS_CONSUMER_SESSION_SELECTOR = `html[${PREVIOUS_SESSION_ATTRIBUTE}="consumer"]`;

/** Inline <head> script: runs before the first paint, like the color scheme one. */
export const previousSessionHintScript = `try{var s=localStorage.getItem("${PREVIOUS_SESSION_KEY}");if(s)document.documentElement.setAttribute("${PREVIOUS_SESSION_ATTRIBUTE}",s)}catch(e){}`;

/**
 * Re-syncs the attribute from localStorage, for when the session changed after
 * the page loaded (logout, login) without a reload.
 */
export const syncPreviousSessionHint = () => {
  try {
    const previousSession = localStorage.getItem(PREVIOUS_SESSION_KEY);
    if (previousSession) {
      document.documentElement.setAttribute(
        PREVIOUS_SESSION_ATTRIBUTE,
        previousSession
      );
    } else {
      document.documentElement.removeAttribute(PREVIOUS_SESSION_ATTRIBUTE);
    }
  } catch {
    // Storage blocked: keep whatever the attribute says (or the guest default).
  }
};
